import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { repurchaserate: { getRepurchaserate } } = apiUrls;

export const REPURCHASE_RATE_SUCCESS = 'REPURCHASE_RATE_SUCCESS';
export const REPURCHASE_RATE_LOADING = 'REPURCHASE_RATE_LOADING';


export const getRepurchaseRateData = ({ fromDate, toDate, salesChannel,
     productCategorizationBasedOn, vendor }) => async (dispatch) => {
        try {
        if (vendor) {
            const { url } = getRepurchaserate
            const requestData = {
                ...getRepurchaserate, url: getRepurchaserate.url.replace('{{vendor}}', vendor),
                data: {
                    fromDate,
                    toDate,
                    productCategorizationBasedOn,
                    salesChannel
                }  
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: REPURCHASE_RATE_SUCCESS,
                data,
                vendor
            })
        }
        } catch (e) {

            dispatch({
                type: REPURCHASE_RATE_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
                vendor
            })
        }

    }



export const handleLoader = (isLoading, vendor ) => (dispatch) => {
    if (vendor) {
    dispatch({
        type: REPURCHASE_RATE_LOADING,
        isLoading,
        vendor
    })
}
}
